export default {
  path: "/account/password-reset/:token",
  name: "password-reset.index",
  component: () => import("@/views/Account/PasswordReset/Index.vue"),
};
